exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".floating-button-panel {\n    position: fixed;\n    background: white;\n    padding: 6px 12px;\n    z-index: 9999;\n    border-left: 8px solid red;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    box-shadow: 1px 1px 2px #666666;\n    margin-top: 4px;\n    left: 100%;\n    margin-left: -16px;\n    transition: 0.2s;\n    white-space: nowrap;\n}\n\n.floating-button-panel.custom_style_all_pricings {\n    border-left: 8px solid blue;\n    margin-top: 36px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/floating-button/styles.css
// module id = 1212
// module chunks = 9